import React from 'react';
import { useFormik } from 'formik';
import { postDataToTheServer, putDataToTheServer } from '../../../helpers/api';
import AppURL from '../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../constants/Toast';
import Container from '../../../constants/Container';
import SecHeading from '../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../constants/InputTextBox';
import NepaliInputBox from '../../../constants/NepaliInputBox';
import { handleNepaliInputChange } from '../../../helpers/handleChange';
import { EndBaseLine } from '../../../constants/AppSpace';
import { Button } from '../../../constants/Button';
import { toleValidationSchema } from '../../../helpers/validation';

interface MargaToleAddFormViewProps {
    handleFormSuccess: () => void;
}
const MargaToleCreateView: React.FC<MargaToleAddFormViewProps> = ({ handleFormSuccess }) => {
    const initialValues = {
        tole_name: "",
        tole_name_nep:"",
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        validationSchema: toleValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("tole_name", values.tole_name);
            formData.append("tole_name_nep", values.tole_name_nep);
            try {
                await postDataToTheServer(AppURL.FrontOfficeURL + 'front/marga/tole/create/list/view/', formData).then((res) => {
                    if(res?.status===201){
                        handleFormSuccess();
                        ToastSuccess({ message: res?.message });
                        action.resetForm();
                    }else if(res?.status===400){
                        ToastWarning({ message: res?.message?.tole_name });
                    }
                    else{
                        ToastWarning({ message: "Some Issue" });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Marga/Tole Add' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='tole_name'
                            label='Marga/Tole Name'
                            handleChange={handleChange}
                            value={values.tole_name}
                            error={typeof errors.tole_name === 'string' ? errors.tole_name : undefined}
                            handleBlur={handleBlur}
                            touched={touched.tole_name}
                            required={true}
                            placeholder='Enter Marga/Tole Name'
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Marga/Tole Name(Nepali)'
                            name='tole_name_nep'
                            value={values.tole_name_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'tole_name_nep' })}
                            required={true}
                            handleBlur={handleBlur}
                            error={typeof errors.tole_name_nep === 'string' ? errors.tole_name_nep : undefined}
                            placeholder='Enter Marga/Tole nepali name'
                            touched={touched.tole_name_nep}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default MargaToleCreateView